/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessageListItem.vue?vue&type=template&id=a9213b3a"
import script from "./ChatMessageListItem.vue?vue&type=script&lang=js"
export * from "./ChatMessageListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9213b3a')) {
      api.createRecord('a9213b3a', component.options)
    } else {
      api.reload('a9213b3a', component.options)
    }
    module.hot.accept("./ChatMessageListItem.vue?vue&type=template&id=a9213b3a", function () {
      api.rerender('a9213b3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/chat-message-list/ChatMessageListItem.vue"
export default component.exports